module.exports = __webpack_public_path__ + "img/addMore.03319b3d.svg";